export const settingsCarrousel = {
	dots: true,
	infinite: true,
	speed: 500,
	slidesToShow: 1,
	slidesToScroll: 1,
	nextArrow: <></>,
	prevArrow: <></>,
	appendDots: (dots: any) => (
		<div style={{ position: 'absolute', bottom: 10, right: 1, width: '64px' }}>
			<ul style={{ margin: '0px',  }} className="dots-wrapper"> {dots} </ul>
		</div>
	),
};